import { createSelector } from 'reselect';

const globalPermissionIds = (state) => state.globalPermissions.ids;

export const getGlobalPermissionsById = (state) => state.entities.globalPermissions || {};

export const getGlobalPermissionsIsLoading = (state) => state.globalPermissions.isLoading;

export const getAllGlobalPermissions = createSelector(
  [getGlobalPermissionsById, globalPermissionIds],
  (globalPermissions, ids) => ids.map((id) => globalPermissions[id]),
);
